import { Authenticated } from "@refinedev/core";
import { Animation } from "../components/animation/Animation";

export const MediaCuepointsAnimation = () => {
  return (
    <Authenticated key={"mediaCuepointsEditor"}>
      <Animation />
    </Authenticated>
  );
};
